import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style/index.js'
import { useTheme } from 'modules/styles/index.js'

export const EditIcon = (props) => {
  const theme = useTheme()
  const defaultStyle = {
    color: theme.colors.text
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={
        getStyleComponentUtil(defaultStyle, props.style)
      }
      className='icon--edit'
      viewBox='0 0 32 32'
    >
      <path
        d='M21.9,4.5c-0.1,0-0.3,0.1-0.4,0.2L6.1,20C6,20.1,6,20.2,6,20.3l-1.5,6.5c-0.1,0.3,0.1,0.6,0.4,0.7c0.1,0,0.2,0,0.3,0 l6.5-1.5c0.1,0,0.2-0.1,0.3-0.2l15.4-15.4c0.2-0.2,0.2-0.6,0-0.8c0,0,0,0,0,0l-5-5C22.2,4.5,22,4.4,21.9,4.5z M21.9,5.9l4.2,4.2 L11.6,24.6l-4.2-4.2L21.9,5.9z M6.9,21.6l3.5,3.5l-4.6,1L6.9,21.6z'
      />
    </svg>
  )
}
